import { node } from 'prop-types';
import React, { useEffect, useMemo, useCallback } from 'react';
import StoreQuickviewContext from '../../contexts/StoreQuickviewContext';

export const QUICKVIEW_PRODUCT_DATA_KEY = 'quickviewProductData';

export function removeStoredQuickview() {
  localStorage.removeItem(QUICKVIEW_PRODUCT_DATA_KEY);
}

const StoreQuickviewProvider = ({
  children,
  orderItemId,
  setIsModalOpen,
  setQuickviewData,
}) => {
  const storeQuickview = useCallback((ProductPageState) => {
    const sku = ProductPageState.sku ?? ProductPageState?.collectionData?.qualifiedSku;

    if (ProductPageState.quickview) {
      localStorage.setItem(QUICKVIEW_PRODUCT_DATA_KEY, JSON.stringify({
        sku,
        orderItemId,
        productId: ProductPageState.productId,
        collectionId: ProductPageState.collectionId,
        faceout: ProductPageState.faceout,
        isStylitics: ProductPageState.isStylitics,
        categoryId: ProductPageState.categoryId,
        type: ProductPageState.type,
      }));
    }
  }, [orderItemId]);

  const contextValue = useMemo(() => ({ storeQuickview }), [storeQuickview]);

  useEffect(() => {
    const storedQuickviewData = localStorage.getItem(QUICKVIEW_PRODUCT_DATA_KEY);
    if (storedQuickviewData) {
      setIsModalOpen(true);
      setQuickviewData({
        ...JSON.parse(storedQuickviewData),
      });
      removeStoredQuickview();
    }
  });

  return (
    <StoreQuickviewContext.Provider value={contextValue}>
      {children}
    </StoreQuickviewContext.Provider>
  );
};

StoreQuickviewProvider.propTypes = {
  children: node.isRequired,
};

export default StoreQuickviewProvider;
